<div 
     
    [ngStyle]="{
        'width':this.dialogdata.width
    }">
    <mat-toolbar 
        style="background-color: #92d3e1; height: 35px;"
        >
        <div 
            style="width: 100%; display: inline-flex; justify-content: space-between;"
            >
            <h6 style="color: black; font-weight: 400;">
                {{title}}
            </h6>
            <img class="close" src="../../../../../../assets/images/wow-circled-x-icon.svg" alt="close"
                (click)="closeDialog()">
        </div>
    </mat-toolbar>
    <mat-dialog-content 
        [innerHTML]="message" 
        class="component-delete-confirm"
        >
        <div 
            class="md-dialog-content user-role-dialog-content" 
            style="padding-top: 12px; padding-left: 18px;"
            >
            <span style="color: black; font-size: 14px;" >
                {{message}}
            </span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions 
        *ngIf="!isCancelNo" 
        align="end" 
        style="margin-bottom: -4px;  padding-right: 10px;"
        >
        <button 
            class="prim-button" 
            *ngIf="dialogdata.showNo" 
            style="margin-right: 15px;" 
            (click)="onNoClick()"
            >
                NO
            </button>
        <button  *ngIf="action.yes.text"
            class=" sec-button"
            [ngClass]="{
                'red-text': dialogdata?.updateDialog
            }"
            style="height: 28px;" 
            (click)="onYesClick()"
            >
                {{action.yes.text}}
            </button>
    </mat-dialog-actions>

    <mat-dialog-actions 
        *ngIf=" isCancelNo && yesContinue" 
        align="end" 
        style="margin-bottom: -4px;  padding-right: 10px;"
        >
        <button class="prim-button" *ngIf="dialogdata.showYes" style="margin-right: 15px;" (click)="onNoClick()">
            {{action.no.text}}
        </button>
        <button class="sec-button" *ngIf="dialogdata.showYes" style="height: 28px;width: 130px;" (click)="onYesClick()">
            YES,CONTINUE
        </button>
    </mat-dialog-actions>

    <mat-dialog-actions 
        *ngIf="isCancelNo && isConfirm" 
        align="end" 
        style="margin-bottom: -4px;  padding-right: 10px;">
        <button class="sec-button"  style="margin-right: 15px;" (click)="onNoClick()">
            Cancel
        </button>
        <button class="prim-button"  style="height: 28px;width: 116px !important;" (click)="onYesClick()">
            Confirm
        </button>
    </mat-dialog-actions>

    <mat-dialog-actions 
        *ngIf="isCancelNo && viewAlert" 
        align="end" 
        style="margin-bottom: -4px;  padding-right: 10px;"
        >
        <button 
            class="cancelNo" 
            style="margin-left: 10px;" 
            (click)="onYesClick()"
            >
            VIEW ALERT
        </button>
    </mat-dialog-actions>
    <mat-dialog-actions 
        *ngIf="isOk" 
        align="end" 
        style="margin-bottom: -4px;  padding-right: 10px;"
        >
        <button class="cancelNo" style="margin-left: 10px;" (click)="onOKClick()">OK</button>
    </mat-dialog-actions>

</div>
